import Setting from './Setting/index' ;
import axios from 'axios' ;
import * as qs from 'querystring' ;
import { createStore } from "vuex";

const debug = process.env.NODE_ENV !== 'production' ;

export default createStore({
  modules: {
    Setting
  },
  state: {
    activeChat: {},
    activeCallData: '111',
    activeSidebar: '1111',
    addressBook: [],
    callStatus: false,
    virtualNumbers: [],
    deleteAllFlag: false,
    deleteAllRecordsFlag: false,
    mainSearch:{
      activity: '',
      searchKey: ''
    },
    activitySearch: {
      activity: '',
      searchKey: ''
    },
    activityCall: {
      isActive: false,
      v_id: '',
      from: '',
      to: ''
    },
    activitySms: {
      isActive: false,
      v_id: '',
      from: '',
      to: '',
      smsText: ''
    },
    credit: 0,
    telinputOption: {id: 'uniqId' , type:'tel' ,autocomplete:'on', maxlength:'25',name:'telephone',placeholder:'Enter a phone number' ,tabindex:'0'}
  },
  mutations: {
    loginUserDetail (state, val) {
      state.loginUserDetail = val
    },
    msgActiveChat (state, val) {
      state.activeChat = val
    },
    activeCallDetail (state, val) {
      state.activeCallData = val
    },
    activeSidebar (state, val) {
      state.activeSidebar = val
    },
    userAddressBook (state, val) {
      state.addressBook = val
    },
    callStatusUpdate (state, val) {
      state.callStatus = val
    },
    virtualNumbers (state, val) {
      state.virtualNumbers = val
    },
    deleteAllFlag (state, val) {
      state.deleteAllFlag = val
    },
    deleteAllRecordsFlag (state, val) {
      state.deleteAllRecordsFlag = val
    },
    mainSearch(state,val){
      state.mainSearch.activity = val.activity
      state.mainSearch.searchKey = val.searchKey
    },
    activitySearch (state, val) {
      state.activitySearch.activity = val.activity
      state.activitySearch.searchKey = val.searchKey
    },
    accountCredit (state, val) {
      state.credit = val
    },
    activityCall (state, val) {
      state.activityCall.isActive = val.isActive
      state.activityCall.v_id = val.v_id
      state.activityCall.from = val.from
      state.activityCall.to = val.to
    },
    activitySms (state, val) {
      state.activitySms.isActive = val.isActive
      state.activitySms.v_id = val.v_id
      state.activitySms.from = val.from
      state.activitySms.to = val.to
      state.activitySms.smsText = val.smsText
    }
  },
  actions: {
    btGetApi (context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(payload.url, qs.stringify(payload.data), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(response => {
          if (response.data[0].status === 'success') {
            resolve(response)
          } else {
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    btPostApi (context, payload) {
      return new Promise((resolve) => {
        axios.post(payload.url, qs.stringify(payload.data), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(response => {
          resolve(response)
        }).catch(() => {
          // resolve(error)
          // blacktel.showSnackbar('error', 'Internal server error.');
          console.log('Internal Server error');
          // reject(error)
        })
      })
    },
    msgActiveChat (context, payload) {
      context.commit('msgActiveChat', payload)
    },
    activeCallDetail (context, payload) {
      context.commit('activeCallDetail', payload)
    },
    activeSidebar (context, payload) {
      context.commit('activeSidebar', payload)
    },
    userAddressBook (context, payload) {
      context.commit('userAddressBook', payload)
    },
    virtualNumbers (context, payload) {
      context.commit('virtualNumbers', payload)
    },
    callStatusUpdate (context, payload) {
      context.commit('callStatusUpdate', payload)
    },
    deleteAllFlag (context, payload) {
      context.commit('deleteAllFlag', payload)
    },
    deleteAllRecordsFlag (context, payload) {
      context.commit('deleteAllRecordsFlag', payload)
    },
    mainSearch(context,payload){
      context.commit('mainSearch',payload)
    },
    activitySearch (context, payload) {
      context.commit('activitySearch', payload)
    },
    accountCredit (context, payload) {
      context.commit('accountCredit', payload)
    },
    activityCall (context, payload) {
      context.commit('activityCall', payload)
    },
    activitySms (context, payload) {
      context.commit('activitySms', payload)
    }
  },
  getters: {
    callStatus: state => state.callStatus,
    deleteAllFlag: state => state.deleteAllFlag,
    deleteAllRecordsFlag: state => state.deleteAllRecordsFlag,
    virtualNumbers: state => state.virtualNumbers,
    mainSearch: state => state.mainSearch.searchKey,
    activitySearch: state => state.activitySearch.searchKey,
    accountCredit: state => state.credit,
    activityCall: state => state.activityCall.isActive,
    activitySms: state => state.activityCall.isActive,
    telinputOption: state => state.telinputOption
  },
  strict: debug
})
